/* Small progressive enhancements; original Shopify form/gallery hooks remain in use. */
(() => {
  document.querySelectorAll('.ref-ambassador-card').forEach(card => {
    const bio=card.querySelector('.ref-ambassador-card__line + p');
    if (!bio || card.querySelector('.site-profile-bio')) return;
    const name=card.querySelector('h2,h3')?.textContent.trim().split(/\s+/)[0] || 'the player';
    const details=document.createElement('details');
    details.className='site-profile-bio';
    const summary=document.createElement('summary');
    summary.append(document.createTextNode('About '+name+' '));
    const sign=document.createElement('span');sign.textContent='+';sign.setAttribute('aria-hidden','true');summary.append(sign);
    const content=document.createElement('div');
    bio.before(details);content.append(bio);details.append(summary,content);
  });
  document.querySelectorAll('.desktop-nav a').forEach(link=>{
    if(new URL(link.href,location.href).pathname===location.pathname && !link.hash) link.setAttribute('aria-current','page');
  });
})();
